module.exports = __webpack_public_path__ + "assets/justify-to-right-icon.677045c5.svg";